define('controllers/incentive/myIncentive-detail.ctrl',['app', 'mainCons'], function (app, mainCons) {

    app.controller('incentiveDetailCtrl', ['$q', '$stateParams', '$location', '$state', 'auiDialog', '$scope', 'UserInfo', '$rootScope', 'OpenOther', 'OpenApp', 'myIncentiveService',
        function ($q, $stateParams, $location, $state, auiDialog, $scope, UserInfo, $rootScope, OpenOther, OpenApp, myIncentiveService) {
            var lang = 'zh_CN';
            var Model = $scope.Model = {
                acceptance: {},
                kitsList: [],
                hmsKitIds: [],
                appFunctionList: []
            };
            Model.constant = {
                promoteItem: mainCons.incentiveConstant.promoteItem,
                applyType: mainCons.incentiveConstant.applyType,
                serviceItems: mainCons.incentiveConstant.serviceItems,
                prodType: mainCons.appConstant.prodType,
                state: mainCons.incentiveConstant.state
            };

            var serialNum = $stateParams.serialNum;
            var appName = $stateParams.appName;

            Model.backToList = backToList;

            init();
            function init() {
                queryAcceptanceList();
            }

            function queryAcceptanceList() {
                OpenOther.getAcceptanceList({
                    req: {
                        serialNum: serialNum,
                        fromRecCount: 1,
                        pageSize: 1
                    }
                }).then(function (data) {
                    if (data && data.resultCode == 0 && data.acceptanceList && data.acceptanceList.length > 0) {
                        Model.acceptance = data.acceptanceList[0];
                        Model.acceptance.appName = appName;
                        var appIDs = [data.acceptanceList[0].appID];
                        Model.productType = Model.acceptance.productType;
                        if(Model.productType == 1){
                            queryProdType(appIDs, data.acceptanceList[0].grandChildType);
                        }else{
                            queryHmProductType(appIDs, data.acceptanceList[0].grandChildType);
                        }

                        if (data.acceptanceList[0].grandChildType) {
                            Model.acceptance.grandChildType = data.acceptanceList[0].grandChildType;
                            var funID = data.acceptanceList[0].functionIdList.split(",");
                            getAppFunctionList(Model.acceptance.grandChildType, funID);
                        }
                        if (Model.acceptance.promoteItem == 3 || Model.acceptance.promoteItem == 4) {
                            myIncentiveService.getKitList().then(function (kitList) {
                                Model.kitsList = kitList;
                            });
                            Model.hmsKitIds = Model.acceptance.hmsKits.split(',');
                        }
                        getDeliveriesIncentiveType();
                    } else {
                        auiDialog.fail("获取申请记录失败。");
                    }
                }).catch(function (data) {
                        auiDialog.failSystemError($filter('auiErrorCode')(data.NSP_STATUS));
                });
            }

            function queryProdType(appIDs, grandChildType) {
                OpenOther.queryInsAppList({
                    req: {
                        prodIDList: AUI.BaseJSUtil.unique(appIDs)
                    }
                }).then(function (resp) {
                    if (resp && resp.appSrvList && resp.appSrvList.length > 0) {
                        Model.prodType = resp.appSrvList[0].appInfo.prodType;
                        var parentType = resp.appSrvList[0].appInfo.parentType;
                        Model.parentTypeName = grandChildType ? "应用" : (parentType == 13 ? "应用" : "游戏");
                    }
                });
            }
            function queryHmProductType(appIDs, grandChildType) {
                OpenApp.queryDstbAppInfo({
                    req:{
                        appID:appIDs[0]
                    }
                }).then(function (resp) {
                    if (resp && resp.dstbAppSrvInfo && resp.dstbAppSrvInfo.dstbAppInfo) {
                        Model.prodType = resp.dstbAppSrvInfo.dstbAppInfo.prodType;
                        var parentType = resp.dstbAppSrvInfo.dstbAppInfo.parentType;
                        Model.parentTypeName = grandChildType ? "应用" : (parentType == 13 ? "应用" : "游戏");
                    }
                }).catch(function (e) {
                })
            }


            // 获取激励类型枚举值映射
            function getDeliveriesIncentiveType() {
                var promoteItemListArray = [];
                Model.prmtLangObj2 = {};
                promoteItemListArray = [Model.acceptance.promoteItem];
                myIncentiveService.getPromotionItemList(promoteItemListArray).then(function (data) {
                    if (data && data.length > 0) {
                        data.forEach(function (item) {
                            Model.prmtLangObj2[item.prmtId] = item.prmtLang
                        })
                    }
                });
            }

            function getAppFunctionList(grandChildType, funID) {
                var defer = $q.defer();
                var params = {
                    req: {
                        lang: lang,
                        grandChildType: grandChildType
                    }
                };
                OpenOther.queryAppFunctionList(params).then(function (resp) {
                    Model.functions = [];
                    Model.grandChilds = [];
                    Model.childTypeName = resp.appFunctionDatas[0].childTypeName;
                    Model.grandChildTypeName = resp.appFunctionDatas[0].grandChildInfos[0].grandChildTypeName;
                    if (resp.appFunctionDatas && resp.appFunctionDatas.length > 0) {
                        resp.appFunctionDatas.forEach(function (appFunctionData) {
                            if (appFunctionData.grandChildInfos && appFunctionData.grandChildInfos.length > 0) {
                                appFunctionData.grandChildInfos.forEach(function (fun) {
                                    if (fun.functions && fun.functions.length > 0) {
                                        fun.functions.forEach(function (functions) {
                                            for (var i = 0; i < funID.length; i++) {
                                                if (funID[i] == functions.functionId) {
                                                    Model.functions.push(functions);
                                                }
                                            }
                                        })
                                    }
                                })
                            }
                        })
                    }
                }).catch(function (resp) {
                    defer.reject();
                    auiDialog.failSystemError($filter('auiErrorCode')(resp.NSP_STATUS));
                });
                return defer.promise;
            }


            function backToList() {
                $state.go('myIncentive');
            }

        }]);
});
